import { useRef } from "react";
import emailjs from "emailjs-com";
import { MdOutlineEmail } from "react-icons/md";
import { AiOutlineLinkedin } from "react-icons/ai";
import { BsWhatsapp } from "react-icons/bs";
import { FaTelegramPlane } from "react-icons/fa";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_5adt7r2",
        "template_xwhev2o",
        form.current,
        "AIiWrJixfT4KCWi4U"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact_container">
        <div className="contact_options">
          <article className="contact_option">
            <MdOutlineEmail className="contact_option-icon" />
            <h4>Email</h4>
            <h5>amirh.ebrahimi17@gmail.com</h5>
            <a href="mailto:amirh.ebrahimi17@gmail.com" target="_blank">
              send a message
            </a>
          </article>
          <article className="contact_option">
            <FaTelegramPlane className="contact_option-icon" />
            <h4>Telegram</h4>
            <h5>@amirjzp</h5>
            <a href="https://t.me/amirjzp" target="_blank">
              send a message
            </a>
          </article>
          <article className="contact_option">
            <BsWhatsapp className="contact_option-icon" />
            <h4>WhatsApp</h4>
            <h5>+989017616117</h5>
            <a
              href="https://api.whatsapp.com/send?phone=989017616117"
              target="_blank"
            >
              send a massage
            </a>
          </article>
        </div>
        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea
            name="message"
            rows="7"
            placeholder="Your Message"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary">
            Send Massage
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
